import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Filter } from '../../components/filter';

import { TYPES_VIEW } from '../../constans/types-view';
import { ScheduleByWeek } from '../../components/schedule';
import { Preloader } from '../../components/preloader';
import { connectWSAction, initWSAction } from '../../ws/actions';
import { getFiltersParamsAction } from '../../components/schedule/actions';
import { switchTypeAction } from '../../components/filter/actions';
import './style.scss';

class SpecialistsModule extends React.Component {
    componentDidMount() {
        const { dispatch, filter } = this.props;

        dispatch(getFiltersParamsAction());
        dispatch(switchTypeAction(TYPES_VIEW[1]));
        dispatch(connectWSAction({ ...filter, typeView: TYPES_VIEW[1] }));
    }

    render() {
        const {
            dispatch,
            schedule,
            filter,
            ws
        } = this.props;
        const { services } = schedule;
        const { typeView } = filter;

        if (ws.ws) {
            dispatch(initWSAction(ws, typeView));
        }

        if (services === null) {
            return <Preloader />;
        }

        return (
            <div className="module-specialists">
                <Filter />
                <ScheduleByWeek />
            </div>
        );
    }
}

SpecialistsModule.propTypes = {
    dispatch: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired,
    schedule: PropTypes.object.isRequired,
    ws: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    filter: state.filter,
    schedule: state.schedule,
    ws: state.ws
});

export default connect(mapStateToProps)(SpecialistsModule);
